import React from 'react'
import PropTypes from 'prop-types'
import HeaderCell from './HeaderCell'
import css from '../styles.css'

const Header = ({
  sortCol,
  sortDir,
  handleSortThenFetchPatients,
}) => (
  <ul className={css.header}>
    <li className={css.headerRow}>
      <HeaderCell
        label='first name'
        colName='first_name'
        cssClass={css.name_first}
        active={sortCol === 'first_name'}
        asc={sortDir === 'asc'}
        handleSortThenFetchPatients={handleSortThenFetchPatients}
      />
      <HeaderCell
        label='last name'
        colName='last_name'
        cssClass={css.name_last}
        active={sortCol === 'last_name'}
        asc={sortDir === 'asc'}
        handleSortThenFetchPatients={handleSortThenFetchPatients}
      />
      <HeaderCell
        label='reminders email'
        cssClass={css.email}
      />
      <HeaderCell
        label='reminders phone'
        cssClass={css.phone}
      />
    </li>
  </ul>
)

Header.propTypes = {
  sortCol: PropTypes.oneOf(['first_name', 'last_name']).isRequired,
  sortDir: PropTypes.oneOf(['asc', 'desc']).isRequired,
  handleSortThenFetchPatients: PropTypes.func.isRequired,
}

export default Header



// WEBPACK FOOTER //
// ./src/components/PatientGroups/PatientList/Header/index.js